const lottoConfigs = [
  {
    'code': 'jp',
    'name': 'นิเคอิ',
    'flag': 'flag-icon-jp',
    'rounds': [
      {
        'rcode': 'r1',
        'rname': 'เช้า',
        'time': '09:05'
      },
      {
        'rcode': 'r2',
        'rname': 'บ่าย',
        'time': '13:25'
      }
    ]
  },
  {
    'code': 'cn',
    'name': 'จีน',
    'flag': 'flag-icon-cn',
    'rounds': [
      {
        'rcode': 'r1',
        'rname': 'เช้า',
        'time': '10:05'
      },
      {
        'rcode': 'r2',
        'rname': 'บ่าย',
        'time': '14:25'
      }
    ]
  },
  {
    'code': 'hk',
    'name': 'ฮั่งเส็ง',
    'flag': 'flag-icon-hk',
    'rounds': [
      {
        'rcode': 'r1',
        'rname': 'เช้า',
        'time': '10:35'
      },
      {
        'rcode': 'r2',
        'rname': 'บ่าย',
        'time': '15:25'
      }
    ]
  },
  {
    'code': 'tw',
    'name': 'ไต้หวัน',
    'flag': 'flag-icon-tw',
    'rounds': [
      {
        'rcode': 'r2',
        'rname': 'บ่าย',
        'time': '11:35'
      }
    ]
  },
  {
    'code': 'kr',
    'name': 'เกาหลี',
    'flag': 'flag-icon-kr',
    'rounds': [
      {
        'rcode': 'r2',
        'rname': 'บ่าย',
        'time': '12:35'
      }
    ]
  },
  {
    'code': 'sg',
    'name': 'สิงคโปร์',
    'flag': 'flag-icon-sg',
    'rounds': [
      {
        'rcode': 'r2',
        'rname': 'บ่าย',
        'time': '17:05'
      }
    ]
  },
  {
    'code': 'in',
    'name': 'อินเดีย',
    'flag': 'flag-icon-in',
    'rounds': [
      {
        'rcode': 'r2',
        'rname': 'บ่าย',
        'time': '17:45'
      }
    ]
  }
]

export { lottoConfigs }
